/// <reference path="PlacementInfoBox.ts" />

namespace TerminalApp {
    export class ToteContentInfoBox {
        container: HTMLElement;
        inner_container: HTMLElement;
        text_container: HTMLElement;
        placementId: number;
        toteId: number;
        placementInfoBox: PlacementInfoBox;
        checkbox: SP.CheckboxDoodle;
        constructor(toteInfo: SP.ToteInfo) {
            this.placementId = toteInfo.totePlacementId;
            this.toteId = toteInfo.toteId;
            this.container = document.createElement("div");
            this.container.classList.add("tote_content_wrapper");


            this.inner_container = document.createElement("div")
            this.inner_container.classList.add("tote_content_box");

            //cb
            var cb = this.container.appendChild(document.createElement("input"));
            cb.type = "checkbox";
            //cb.checked = true;
            this.checkbox = new SP.CheckboxDoodle(cb);

            


            this.placementInfoBox = new PlacementInfoBox(toteInfo.totePlacementData, true, null);
            this.inner_container.appendChild(this.placementInfoBox.container);
            var qty = document.createElement("div");
            qty.classList.add("label", "label-success");
            qty.innerHTML = toteInfo.totePlacementQuantity.toString();
            this.inner_container.appendChild(qty);
            this.container.appendChild(this.inner_container);
        }
    }

}